/**
 * One definition of "price mismatch" for the store dashboard: a Shopify listing
 * the pricing audit flagged for a price problem (below MAP, priced far under MAP,
 * old price, old compare-at, no price). A listing with only `unmapped_variant`
 * has no Motzu price to disagree with, so it is counted in its own bucket
 * (`summary.unmappedVariant`) and never here. This matches the Shopify Pricing
 * Audit page's per-issue stats, which the dashboard breakdown lists.
 */
export function countPriceMismatchFindings(
  findings: Array<{ hasIssue: boolean; issues?: string[] }>
): number {
  return findings.filter((f) => {
    if (!f.hasIssue) return false;
    if (!f.issues) return true;
    return f.issues.some((issue) => issue !== 'unmapped_variant');
  }).length;
}
